import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    delay:     { type: Number, default: 0 },
    threshold: { type: Number, default: 0.15 }
  }

  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.element.classList.add("is-visible")
      return
    }

    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setTimeout(() => entry.target.classList.add("is-visible"), this.delayValue)
          this.observer.unobserve(entry.target)
        }
      })
    }, { threshold: this.thresholdValue, rootMargin: "0px 0px -40px 0px" })

    this.observer.observe(this.element)
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }
}
